
import React from "react";
import MainRouter from './main_router/MainRouter';
// import { createContext, useEffect, useState } from "react";

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <div>
        <MainRouter />
      </div>

      </header>
    </div>
  );
}

export default App;
